<button class="btn btn-primary" type="submit">
  <ng-container *ngIf="!isPending; else pending">
    {{ buttonText }}
  </ng-container>
</button>

<ng-template #pending>
  <i class="fal fa-fw fa-spinner-third fa-spin" aria-hidden="true"></i>
  {{ buttonPendingText }}
</ng-template>
